
import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../../react-app-env';

const _createPotPathwayInitQuery = (speciality_id: string, category_id: string) => ({
  specialities_by_pk: params(
    { id: rawString(speciality_id) },
    {
      id: types.string,
      name: types.string,
    },
  ),
  speciality_categories_by_pk: params(
    { id: rawString(category_id) },
    {
      id: types.string,
      name: types.string,
    },
  )
});

type X = Unpacked<typeof _createPotPathwayInitQuery>
export type Speciality = X['specialities_by_pk'];
export type Category = X['speciality_categories_by_pk'];

export const createPotPathwayInitQuery = (speciality_id: string, category_id: string) => gql`${query(_createPotPathwayInitQuery(speciality_id, category_id))}`;
